export { default } from './BottomBanner';
